// requestMessage.js
import qs from 'qs';
import { VITE_API_MESSAGE } from './host';
import { getTokenMessage } from '../utils/safeStorage';

const getToken = getTokenMessage;

const handleResponse = async (response) => {
  const data = await response.json();
  data.statusCode = response.status;
  return data;
};

const buildHeaders = () => {
  const token = getToken();
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
};

const GET = async (url, params = {}) => {
  const token = getToken();
  const queryString = qs.stringify(params, { arrayFormat: 'brackets' });

  const response = await fetch(`${VITE_API_MESSAGE}${url}?${queryString}`, {
    method: 'GET',
    headers: buildHeaders(),
  });

  return handleResponse(response);
};

const POST = async (url, data = {}) => {
  const isFormData = data.body instanceof FormData;

  const response = await fetch(`${VITE_API_MESSAGE}${url}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      ...(isFormData
        ? {}
        : {
            'Content-Type': 'application/json',
          }),
      ...(getToken() && {
        Authorization: `Bearer ${getToken()}`,
      }),
    },
    body: isFormData ? data.body : JSON.stringify(data),
  });

  return handleResponse(response);
};

const requestMessage = { GET, POST };

export default requestMessage;
